<template>
  <section class="news-section" style="background: #f7faff">
    <div class="hero-section">
      <div class="container">
        <h1 class="page-title">{{ comp.task }}</h1>
        <p class="page-subtitle">
          {{ comp.f1 }}
        </p>
      </div>
    </div>

    <div
      class="container mt-4 mb-4"
      :style="`max-width: 1200px !important; min-height: ${comp.id === 6490856 ? 'inherit' : '55vh'}`"
    >
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay">
        <div class="loading-content">
          <div class="spinner"></div>
          <p class="loading-text">Түр хүлээнэ үү...</p>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="section-title text-left">
          <p style="color: #6c757d; font-size: 0.9rem; margin-top: 8px;">
            Нийт: {{ tasks.length }}
          </p>
        </div>

        <!-- Search Bar -->
        <div class="search-container">
          <div class="search-box">
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Хайх"
              class="search-input"
            />
            <i class="search-icon">🔍</i>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="table-container">
        <table class="data-table table-bordered table-striped">
          <thead>
            <tr>
              <th style="width: 50px;">№</th>
              <th>ГАРЧИГ</th>
              <th style="width: 100px;">ОГНОО</th>
              <th style="width: 100px;">ХАВСРАЛТ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t, i) in filteredTasks" :key="i" class="table-row">
              <td class="title-cell">{{ i + 1 }}</td>
              <td class="title-cell">{{ t.task }}</td>
              <td class="date-cell">
                {{ t.createdDate | moment("YYYY.MM.DD HH:mm") }}
              </td>
              <td class="type-cell">
                <a
                  @click="openTask(t)"
                  style="cursor: pointer"
                  class="type-badge"
                  >ТАТАХ</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    
    <div class="container" style="max-width: 1200px !important">
      <div v-if="comp.id === 6490856" class="pb-4 container text-right">
        <router-link :to="{ name: $store.state.app.activeGroup.publicPage.route, params: { id: 6330212, cid: 0 } }" 
        class="btn btn-primary">Бүх тушаалыг харах</router-link>
      </div>
    </div>

  </section>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: [],
      searchQuery: "",
      loading: false
    };
  },
  computed: {
    filteredTasks() {
      if (!this.searchQuery) {
        return this.tasks;
      }
      return this.tasks.filter(task =>
        task.task.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      this.loading = true;
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: this.comp.id === 6490856 ? 10 : 500,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      })
        .then(res => {
          if (res != false) {
            this.tasks = res.data.tasks;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openTask(task) {
      window.open(`${task.defaultAttachmentUrl}`, "_blank");
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  border-radius: 8px;
}

.loading-content {
  text-align: center;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: #495057;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
}

.hero-section {
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("https://res.gosmart.mn/apps/egazar/cover3.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: grayscale(100%);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  color: white;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.page-subtitle {
  color: white;
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 400px;
  margin: 0 auto;
  text-transform: uppercase;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.news-section {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.search-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.search-box {
  position: relative;
  width: 300px;
}

.search-input {
  width: 100%;
  padding: 10px 40px 10px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s ease;
}

.search-input:focus {
  border-color: #007bff;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 16px;
}

.table-container {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table thead {
  background: #f8f9fa;
}

.data-table th {
  padding: 15px 20px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  border-bottom: 1px solid #e9ecef;
}

.data-table tbody tr {
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s ease;
}

.data-table tbody tr:hover {
  background-color: #f8f9fa;
}

.data-table tbody tr:last-child {
  border-bottom: none;
}

.data-table td {
  padding: 15px 20px;
  font-size: 14px;
  color: #333;
}

.title-cell {
  font-weight: 500;
  color: #2c3e50;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.date-cell {
  color: #6c757d;
  font-size: 13px;
  white-space: nowrap;
}

.type-cell {
  text-align: right;
}

.type-badge {
  background: #e3f2fd;
  color: #1976d2;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
  .search-box {
    width: 100%;
  }

  .data-table th,
  .data-table td {
    padding: 12px 15px;
  }

  .title-cell {
    max-width: 200px;
  }
}

@media (max-width: 576px) {
  .data-table {
    font-size: 12px;
  }

  .data-table th,
  .data-table td {
    padding: 10px 12px;
  }

  .title-cell {
    max-width: 150px;
  }
}
</style>
